import React, { useState } from "react";
import { Copy, Check, Link2 } from "lucide-react";
import { api } from "@/platform/api";

const urlFor = (token) => `${window.location.origin}/r/${token}`;
const localUrl = (id) => { try { return localStorage.getItem(`pinlayr_invite_url_${id}`); } catch (_e) { return null; } };

// Copy a reviewer link; older invites without a stored link get one issued on click (old link keeps working).
export function ReviewerLinkCopy({ projectId, inv, testid, label = "Copy link" }) {
  const [url, setUrl] = useState(inv.token ? urlFor(inv.token) : localUrl(inv.id));
  const [state, setState] = useState("idle");

  const copy = async () => {
    let link = url;
    if (!link) {
      setState("loading");
      try {
        const r = await api.post(`/api/projects/${projectId}/reviewer-invites/${inv.id}/link`);
        link = urlFor(r.token);
        setUrl(link);
      } catch (_e) { setState("error"); return; }
    }
    try { await navigator.clipboard?.writeText(link); } catch (_e) { /* ignore */ }
    setState("copied");
    setTimeout(() => setState("idle"), 1600);
  };

  return (
    <button onClick={copy} disabled={state === "loading"} title={url || "Generate a copyable link for this reviewer"}
      className="inline-flex items-center gap-1 text-[12px] font-medium text-[#A99BFF] hover:underline disabled:opacity-60" data-testid={testid}>
      {state === "copied" ? <><Check className="h-3.5 w-3.5" /> Copied</>
        : state === "error" ? <>Couldn't get link</>
        : url ? <><Copy className="h-3.5 w-3.5" /> {label}</>
        : <><Link2 className="h-3.5 w-3.5" /> {state === "loading" ? "Getting link…" : "Get link"}</>}
    </button>
  );
}
